// extracted by mini-css-extract-plugin
export default {"wrapper":"NoteExpertGeneralPageSlider_wrapper__lwUsb","list":"NoteExpertGeneralPageSlider_list__iKtDG","buttonWrapper":"NoteExpertGeneralPageSlider_buttonWrapper__Z3IPb"};